import { Level } from './level';
export class LogHandler {
  constructor() {
    this.level = Level.ALL;
    this.filter = null;
    this.isLoggable = record => {
      if (record.level < this.level || this.level === Level.OFF) {
        return false;
      }
      return this.filter === null ? true : this.filter.isLoggable(record);
    };
  }
  setFilter(filter) {
    this.filter = filter;
  }
  getFilter() {
    return this.filter;
  }
  getLevel() {
    return this.level;
  }
  setLevel(level) {
    this.level = level;
  }
}